import cx from "classnames";

import { ChevronDown } from "components/icons/generated";
import Button from "ds/components/Button";
import DropdownMenu from "ds/components/DropdownMenu";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Tooltip from "ds/components/Tooltip";
import { Module } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellSpace from "ds/components/Table/Row/CellSpace";

const ModulesTableAvailabilityCell = ({
  item: module,
  ...cellProps
}: TableSimpleCellProps<Module>) => {
  const sharedModules = module.moduleShares;
  const availableSpaces = sharedModules
    ?.map((share) => share.to?.space)
    .filter((space) => space !== null);
  const allAvailableSpaces = [module.spaceDetails, ...(availableSpaces || [])];
  const moreTagsTooltip = `${allAvailableSpaces.length} items`;

  return (
    <TableSimpleCell {...cellProps}>
      {allAvailableSpaces?.length === 1 && (
        <TableCellSpace href={`/spaces/${allAvailableSpaces[0]?.id}`}>
          {allAvailableSpaces[0]?.name}
        </TableCellSpace>
      )}
      {allAvailableSpaces?.length > 1 && (
        <DropdownMenu
          triggerComponent={
            <Tooltip
              on={(tooltipProps) => (
                <Button
                  {...tooltipProps}
                  aria-label="Show more items"
                  className={cx(tooltipProps.className)}
                  variant="secondary"
                  size="small"
                  endIcon={ChevronDown}
                  withTextEllipsis
                >
                  {moreTagsTooltip}
                </Button>
              )}
            >
              Show more items
            </Tooltip>
          }
        >
          {allAvailableSpaces.map((space) => {
            return (
              <DropdownMenuItem
                href={`/spaces/${space?.id}`}
                tooltipPlacement="right"
                key={space?.id}
              >
                {space?.name}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenu>
      )}
    </TableSimpleCell>
  );
};

export default ModulesTableAvailabilityCell;
